(function () {
  const isMobile = () => window.innerWidth < 768;

  function initProductCardSwipers(root = document) {
    if (typeof Swiper === 'undefined') return;

    root.querySelectorAll('.product-slider .swiper:not(.swiper-initialized)').forEach(function (swiperEl) {
      if (swiperEl.dataset.disableSlider === 'true') return;
      if (swiperEl.dataset.disableSliderMobile === 'true' && isMobile()) return;

      const slides = swiperEl.querySelectorAll('.swiper-slide');
      const slidesCount = slides.length;
      const paginationEl = swiperEl.querySelector('.swiper-pagination');

      if (!paginationEl) return;

      paginationEl.innerHTML = '';

      if (slidesCount <= 1) {
        swiperEl.classList.add('swiper-no-swiping');
        paginationEl.style.display = 'none';
        const prev = swiperEl.querySelector('.swiper-button-prev');
        const next = swiperEl.querySelector('.swiper-button-next');
        if (prev) prev.style.display = 'none';
        if (next) next.style.display = 'none';
        return;
      }

      for (let i = 0; i < slidesCount; i++) {
        const bullet = document.createElement('div');
        bullet.classList.add('bullet');
        bullet.innerHTML = '<div class="fill"></div>';
        paginationEl.appendChild(bullet);
      }

      const updatePagination = (swiperInstance) => {
        const fills = paginationEl.querySelectorAll('.fill');
        const bullets = paginationEl.querySelectorAll('.bullet');
        const currentIndex =
          swiperInstance.realIndex !== undefined
            ? swiperInstance.realIndex
            : swiperInstance.activeIndex % slidesCount;

        fills.forEach((fill, index) => {
          const isActive = index === currentIndex;
          fill.style.width = isActive ? '100%' : '0%';

          if (bullets[index]) {
            bullets[index].classList.toggle('is-active', isActive);
          }
        });
      };

      const useLoop = slidesCount >= 4;

      new Swiper(swiperEl, {
        loop: useLoop,
        rewind: !useLoop,
        simulateTouch: true,
        touchRatio: 1,
        touchAngle: 45,
        grabCursor: true,
        allowTouchMove: true,
        resistance: true,
        resistanceRatio: 0.85,
        speed: 300,
        navigation: {
          nextEl: swiperEl.querySelector('.swiper-button-next'),
          prevEl: swiperEl.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: paginationEl,
          clickable: false,
          type: 'custom',
        },
        on: {
          init: function () {
            updatePagination(this);
          },
          slideChange: function () {
            updatePagination(this);
          },
        },
      });

      if ('ontouchstart' in window) {
        let touchStartX = 0;

        swiperEl.addEventListener('touchstart', function (e) {
          touchStartX = e.changedTouches[0].screenX;
        });

        swiperEl.addEventListener('touchend', function (e) {
          const touchEndX = e.changedTouches[0].screenX;
          if (Math.abs(touchEndX - touchStartX) > 30) {
            swiperEl.classList.add('show-arrows');
            setTimeout(() => {
              swiperEl.classList.remove('show-arrows');
            }, 3000);
          }
        });
      }
    });
  }

  window.initProductCardSwipers = initProductCardSwipers;

  document.addEventListener('DOMContentLoaded', () => initProductCardSwipers());
  document.addEventListener('shopify:section:load', (event) => initProductCardSwipers(event.target));
  document.addEventListener('collection:grid-updated', (event) => {
    initProductCardSwipers(event.detail?.root || document);
  });
})();
